import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('menopath_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const apiClient = axios.create({
  baseURL: API,
  withCredentials: true
});

apiClient.interceptors.request.use((config) => {
  const headers = getAuthHeaders();
  config.headers = { ...config.headers, ...headers };
  return config;
});

export const api = {
  // Hormonal Data
  createHormonalData: (data) => apiClient.post('/hormones', data),
  getHormonalData: () => apiClient.get('/hormones'),
  getLatestHormonalData: () => apiClient.get('/hormones/latest'),

  // Lifestyle Data
  createLifestyleData: (data) => apiClient.post('/lifestyle', data),
  getLifestyleData: () => apiClient.get('/lifestyle'),
  getLatestLifestyleData: () => apiClient.get('/lifestyle/latest'),

  // Symptoms Data
  createSymptomsData: (data) => apiClient.post('/symptoms', data),
  getSymptomsData: () => apiClient.get('/symptoms'),
  getLatestSymptomsData: () => apiClient.get('/symptoms/latest'),

  // Prediction
  validateData: () => apiClient.post('/validate-data'),
  getPrediction: () => apiClient.post('/predict'),
  getLatestPrediction: () => apiClient.get('/predict/latest'),

  // Profile
  getProfile: () => apiClient.get('/profile'),
  updateProfile: (data) => apiClient.put('/profile', data),
  changePassword: (data) => apiClient.post('/profile/change-password', data),

  // Password Reset
  forgotPassword: (email) => apiClient.post('/auth/forgot-password', { email }),
  resetPassword: (token, newPassword) => apiClient.post('/auth/reset-password', { token, new_password: newPassword }),

  // Email Verification
  verifyEmail: (token) => apiClient.get(`/auth/verify-email?token=${token}`),
  resendVerification: (email) => apiClient.post('/auth/resend-verification', { email }),

  // Data History
  getHormoneHistory: () => apiClient.get('/history/hormones'),
  getLifestyleHistory: () => apiClient.get('/history/lifestyle'),
  getPredictionHistory: () => apiClient.get('/history/predictions'),

  // Account Management
  deleteAccount: (password, confirmation) => apiClient.delete('/account', { 
    data: { password, confirmation } 
  }),

  // Auth Session (for Google OAuth)
  exchangeSession: (sessionId) => 
    axios.get(`${API}/auth/session`, {
      headers: { 'X-Session-ID': sessionId },
      withCredentials: true
    })
};

export default api;
